import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import { Modal } from "react-bootstrap";
import { Addstocks } from "./addstocks";
import moment from "moment";
import { AddTemplateModal } from "./addTemplateModal";
import { AddTemplateCategory } from "./addTemplateCategory";
import "./AddTemplate.css";

// Lucide Icons
import {
  Search,
  X,
  Plus,
  FolderPlus,
  Folder,
  FileText,
  Copy,
  Trash2,
  Filter,
  Calendar,
  Edit2,
} from "lucide-react";
import copy from "copy-to-clipboard";

export function AddTemplate({ adminType }) {
  const adminStore = useSelector((state) => state.adminReducer);

  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showCategory, setShowCategory] = useState(false);
  const handleCloseCategory = () => setShowCategory(false);
  const handleShowCategory = () => setShowCategory(true);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [allCategory, setAllCategory] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const getTemplate = async () => {
    try {
      setLoader(true);
      let payload = {
        category: selectedCategory ? selectedCategory : "",
      };
      const postData = await api.getTemplate(payload);
      setData(postData.data);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  const getTemplateCategory = async () => {
    try {
      setLoader(true);
      const response = await api.getTemplateCategory();
      setAllCategory(response.data);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const deletePost = async (id) => {
    try {
      let payload = {
        id: id,
      };
      setLoader(true);
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this template?",
      );
      if (isConfirmed) {
        const userData = await api.deleteTemplate(payload);
        console.log("deleted");
        getTemplate();
      }

      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const copyTemplateContent = async (content) => {
    try {
      // 1. Create the HTML blob
      const blobHTML = new Blob([content], { type: "text/html" });

      // 2. Create a plain text version (stripping tags) so it works in Notepad too
      const plainText = content.replace(/<[^>]*>/g, "");
      const blobText = new Blob([plainText], { type: "text/plain" });

      // 3. Write both to the clipboard
      const data = [
        new ClipboardItem({
          "text/html": blobHTML,
          "text/plain": blobText,
        }),
      ];

      await navigator.clipboard.write(data);
      alert("Template copied with formatting!");
    } catch (err) {
      console.error("Copy failed", err);
      alert("Failed to copy template.");
    }
  };

  // Filter templates based on search query
  const filteredTemplates = data.filter(
    (template) =>
      template.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      template.template?.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  useEffect(() => {
    getTemplate();
  }, [selectedCategory]);

  useEffect(() => {
    getTemplateCategory();
  }, []);

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid elegant-templates">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-12 d-flex justify-content-between pr-0 flex-wrap elegant-header">
                <div className="header-left">
                  <h4 className="color-dark fs-17 dib font-weight-bold mr-5 elegant-title">
                    <FileText size={24} className="title-icon" />
                    Templates ({data?.length || 0})
                  </h4>
                </div>
                <div className="header-right">
                  <div className="search-box">
                    <Search size={18} className="search-icon" />
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Search templates..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    {searchQuery && (
                      <X
                        size={16}
                        className="clear-search"
                        onClick={() => setSearchQuery("")}
                      />
                    )}
                  </div>
                  {(adminType == "mackAdmin777" ||
                    adminType == "jackAdmin775" ||
                    adminStore?.admin?.admin?.email == "alex@waqarzaka.net" ||
                    adminStore?.admin?.admin?.email ==
                      "sarah@waqarzaka.net") && (
                    <div className="actions-btn">
                      <button
                        className="elegant-btn secondary-btn"
                        onClick={handleShowCategory}
                      >
                        <FolderPlus size={16} />
                        Add Category
                      </button>
                      <button
                        className="elegant-btn primary-btn"
                        onClick={handleShow}
                      >
                        <Plus size={16} />
                        Add Template
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 d-flex justify-content-between ai-center pr-0 flex-wrap mt-4 category-section">
                <div className="category-label">
                  <Filter size={16} />
                  <span>Categories:</span>
                </div>
                <div className="categoryTab elegant-category-tabs">
                  <button
                    className={!selectedCategory ? "active" : ""}
                    onClick={() => setSelectedCategory("")}
                  >
                    <Folder size={14} />
                    All
                  </button>
                  {allCategory.map((val, key) => (
                    <button
                      key={key}
                      onClick={() => setSelectedCategory(val?._id)}
                      className={selectedCategory == val?._id ? "active" : ""}
                    >
                      <Folder size={14} />
                      {val?.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Templates List */}
            {loader ? (
              <div className="elegant-loading">
                <div className="spinner"></div>
                <p>Loading templates...</p>
              </div>
            ) : filteredTemplates.length > 0 ? (
              <div className="templates-list">
                {filteredTemplates.map((val, key) => (
                  <div className="template-card-elegant" key={key}>
                    <div className="template-header">
                      <div className="template-title-section">
                        <h5 className="template-title">
                          <FileText size={16} className="template-icon" />
                          {val?.title}
                        </h5>
                        <div className="template-actions">
                          <button
                            className="action-icon copy-btn"
                            onClick={() => copyTemplateContent(val?.template)}
                            title="Copy template content"
                          >
                            <Copy size={14} />
                          </button>
                          <button
                            className="action-icon delete-btn"
                            onClick={() => deletePost(val?._id)}
                            title="Delete template"
                          >
                            <Trash2 size={14} />
                          </button>
                        </div>
                      </div>
                      {val?.category && (
                        <div className="template-category">
                          <span className="category-tag">
                            {allCategory.find((cat) => cat._id === val.category)
                              ?.name || "Uncategorized"}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="template-content-wrapper">
                      <div
                        className="template-content-elegant"
                        dangerouslySetInnerHTML={{
                          __html: val?.template,
                        }}
                      />
                    </div>
                    <div className="template-footer">
                      <div className="template-dates">
                        <span className="date-item">
                          <Calendar size={12} />
                          Created:{" "}
                          {moment(val?.createdAt).format("MMM DD, YYYY")}
                        </span>
                        {val?.updatedAt && (
                          <span className="date-item">
                            <Calendar size={12} />
                            Updated:{" "}
                            {moment(val?.updatedAt).format("MMM DD, YYYY")}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="elegant-empty-state">
                <FileText size={64} className="empty-icon" />
                <h4>No templates found</h4>
                <p>
                  {searchQuery
                    ? `No templates match your search for "${searchQuery}"`
                    : selectedCategory
                      ? `No templates in this category yet`
                      : "Get started by creating your first template"}
                </p>
                {(adminType == "mackAdmin777" ||
                  adminType == "jackAdmin775" ||
                  adminStore?.admin?.admin?.email == "alex@waqarzaka.net" ||
                  adminStore?.admin?.admin?.email == "sarah@waqarzaka.net") && (
                  <button
                    className="elegant-btn primary-btn"
                    onClick={handleShow}
                  >
                    <Plus size={16} />
                    Add Your First Template
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* /.container-fluid */}

      <Modal
        show={show}
        size="lg"
        onHide={handleClose}
        centered
        className="elegant-modal"
      >
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleClose}>
              <i className="fa-solid fa-xmark" />
            </div>
            <AddTemplateModal
              getTemplate={getTemplate}
              setShow={setShow}
              allCategory={allCategory}
            />
          </div>
        </Modal.Body>
      </Modal>

      {/* add category modal */}
      <Modal
        show={showCategory}
        size="lg"
        onHide={handleCloseCategory}
        centered
        className="elegant-modal"
      >
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleCloseCategory}>
              <i className="fa-solid fa-xmark" />
            </div>
            <AddTemplateCategory
              getTemplateCategory={getTemplateCategory}
              setShow={setShowCategory}
            />
          </div>
        </Modal.Body>
      </Modal>
      {loader && <Loader />}
    </>
  );
}
